import { defineMessages } from "react-intl";
const messages = defineMessages({
    communityUpdateDeactivation: {
        id: "app.admin.updateCommunity.deactivation.button.text",
        defaultMessage: "Deactivate Community",
    },
    deactivateCommunityFormSuccess: {
        id: "app.admin.communities.deactivateCommunityForm.actions.switch.success.text",
        defaultMessage: "Community status successfully deactivated",
    },
    deactivateCommunityFormDescription: {
        id: "app.admin.communities.deactivateCommunityForm.description",
        defaultMessage: "Are you sure you want to deactivate this community? Please, type deactivate to confirm.",
    },
});
export default messages;
